'use client';
import { Table } from 'antd';
import { Entering, LoadingLogo, Pagination, Typography } from 'components';
import { EmptyInboxClipArt } from 'lib/svgs/ClipArts';
import { useTranslations } from 'next-intl';

import { Invoice } from 'gql/graphql';
import 'styles/sass/ant-design/ant-design-table-checkbox.scss';
import { useInvoicesContext } from '../_context/InvoicesContext';
import FilterSortInvoices from './FilterSortInvoices';

export default function TableInvoices() {
  const t = useTranslations();

  const {
    isLoading,
    isPending,
    page,
    setPage,
    totalPages,
    isRetrieving,
    columns,
    invoices,
    handleSelectInvoice
  } = useInvoicesContext();

  const handleOnRow = (invoice: Invoice) => ({
    onClick: handleSelectInvoice(invoice?.id)
  });

  return (
    <div className="">
      <Entering offset={5} delay={0.6} duration={0.2} position="bottom" className="gap-10">
        <div className="">
          <div className="rounded-t-md bg-white shadow-custom">
            <div className="flex justify-between !p-4 !px-6">
              <Typography
                variant="medium1"
                className="relative left-0 top-0 flex text-tertiary-100"
              >
                <span className="flex gap-2">
                  {t('invoices.title')}
                  <span className="text-tertiary-200">({invoices?.nodesCount})</span>
                </span>
              </Typography>
              <span className="flex gap-4">
                <FilterSortInvoices />
              </span>
            </div>
            {(isLoading || isPending) && (
              <div className="grid h-[50vh] flex-1 place-content-center">
                <div className="relative flex flex-col items-center justify-center">
                  <LoadingLogo size="x-small" className="absolute -left-8" />
                </div>
              </div>
            )}

            {!(isLoading || isPending) && !!invoices?.nodesCount && (
              <Table<Invoice>
                key={`${page}`}
                onRow={handleOnRow}
                tableLayout="auto"
                rowClassName="cursor-pointer"
                columns={columns}
                dataSource={invoices?.nodes || []}
                pagination={false}
                scroll={{
                  x: true
                }}
              />
            )}
            {!(isLoading || isPending) && (!invoices?.nodesCount || invoices.nodesCount === 0) && (
              <div className="grid h-[50vh] flex-1 place-content-center">
                <div className="flex flex-col items-center justify-center">
                  <EmptyInboxClipArt />
                  <Typography
                    variant="light3"
                    className="flex max-w-[250px] text-center text-tertiary-200"
                  >
                    {t('invoices.empty')}
                  </Typography>
                </div>
              </div>
            )}
            {!!totalPages && !!page && !isRetrieving && (
              <Pagination
                totalPages={totalPages}
                changePage={setPage}
                page={page}
                className="flex justify-center pb-8 pt-6"
              />
            )}
          </div>
        </div>
        <div className="flex justify-center py-10" />
      </Entering>
    </div>
  );
}
